import Home from '../components/Home/Home'
import Server from '../components/Server/Dashboard'

let routes = {
    path: '/',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
      {
          path: '/',
          name: 'Home',
          component: Server
      },
    ]
}

export default routes
